module.exports = __webpack_public_path__ + "img/mono_15.28b48fa4.png";